import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IdentityField } from 'components/form/IdentityField';
import ReactFinalForm from 'components/form/ReactFinalForm';
import { DatePickerAdapter } from 'components/form/DatePickerAdapter';

export const MaintenanceMonthDataDialog = ({
  openCalendar,
  onCancel,
  onSubmit
}: {
  openCalendar: boolean;
  onCancel: () => void;
  onSubmit: (values: any) => void;
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={openCalendar} onClose={onCancel}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DialogTitle>Seleziona Data</DialogTitle>
        <DialogContent sx={{ width: '400px' }}>
          <ReactFinalForm onSubmit={onSubmit} formId="addMaintenanceDate" hideControls={true}>
            <div className="w-full flex justify-center">
              <div className="w-[400px]">
                <div className="w-full">
                  <IdentityField
                    name="date"
                    component={DatePickerAdapter}
                    label={t('global.date')}
                    required={true}
                  />
                </div>
              </div>
            </div>
          </ReactFinalForm>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel} color="error">
            {t(`actions.cancel`)}
          </Button>
          <Button type="submit" form="addMaintenanceDate">
            {t(`actions.confirm`)}
          </Button>
        </DialogActions>
      </LocalizationProvider>
    </Dialog>
  );
};
